// Unicode CLDR 48 currency regions, verified 2026-10-08.
// Source: https://github.com/unicode-org/cldr-json/blob/main/cldr-json/cldr-core/supplemental/currencyData.json
// Rows contain ISO2, ISO3, and active legal-tender currency codes.
// Refresh this snapshot when currencies change.
/*
UNICODE LICENSE V3

COPYRIGHT AND PERMISSION NOTICE

Copyright © 1991-2026 Unicode, Inc.

NOTICE TO USER: Carefully read the following legal agreement. BY
DOWNLOADING, INSTALLING, COPYING OR OTHERWISE USING DATA FILES, AND/OR
SOFTWARE, YOU UNEQUIVOCALLY ACCEPT, AND AGREE TO BE BOUND BY, ALL OF THE
TERMS AND CONDITIONS OF THIS AGREEMENT. IF YOU DO NOT AGREE, DO NOT
DOWNLOAD, INSTALL, COPY, DISTRIBUTE OR USE THE DATA FILES OR SOFTWARE.

Permission is hereby granted, free of charge, to any person obtaining a
copy of data files and any associated documentation (the "Data Files") or
software and any associated documentation (the "Software") to deal in the
Data Files or Software without restriction, including without limitation
the rights to use, copy, modify, merge, publish, distribute, and/or sell
copies of the Data Files or Software, and to permit persons to whom the
Data Files or Software are furnished to do so, provided that either (a)
this copyright and permission notice appear with all copies of the Data
Files or Software, or (b) this copyright and permission notice appear in
associated Documentation.

THE DATA FILES AND SOFTWARE ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF
THIRD PARTY RIGHTS.

IN NO EVENT SHALL THE COPYRIGHT HOLDER OR HOLDERS INCLUDED IN THIS NOTICE
BE LIABLE FOR ANY CLAIM, OR ANY SPECIAL INDIRECT OR CONSEQUENTIAL DAMAGES,
OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS,
WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION,
ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THE DATA
FILES OR SOFTWARE.

Except as contained in this notice, the name of a copyright holder shall
not be used in advertising or otherwise to promote the sale, use or other
dealings in these Data Files or Software without prior written
authorization of the copyright holder.

*/
export const COUNTRY_CURRENCIES: readonly [string, string, ...string[]][] = [
    ["AC","ASC","SHP"],
    ["AD","AND","EUR"],
    ["AE","ARE","AED"],
    ["AF","AFG","AFN"],
    ["AG","ATG","XCD"],
    ["AI","AIA","XCD"],
    ["AL","ALB","ALL"],
    ["AM","ARM","AMD"],
    ["AO","AGO","AOA"],
    ["AR","ARG","ARS"],
    ["AS","ASM","USD"],
    ["AT","AUT","EUR"],
    ["AU","AUS","AUD"],
    ["AW","ABW","AWG"],
    ["AX","ALA","EUR"],
    ["AZ","AZE","AZN"],
    ["BA","BIH","BAM"],
    ["BB","BRB","BBD"],
    ["BD","BGD","BDT"],
    ["BE","BEL","EUR"],
    ["BF","BFA","XOF"],
    ["BG","BGR","EUR"],
    ["BH","BHR","BHD"],
    ["BI","BDI","BIF"],
    ["BJ","BEN","XOF"],
    ["BL","BLM","EUR"],
    ["BM","BMU","BMD"],
    ["BN","BRN","BND"],
    ["BO","BOL","BOB"],
    ["BQ","BES","USD"],
    ["BR","BRA","BRL"],
    ["BS","BHS","BSD"],
    ["BT","BTN","BTN","INR"],
    ["BV","BVT","NOK"],
    ["BW","BWA","BWP"],
    ["BY","BLR","BYN"],
    ["BZ","BLZ","BZD"],
    ["CA","CAN","CAD"],
    ["CC","CCK","AUD"],
    ["CD","COD","CDF"],
    ["CF","CAF","XAF"],
    ["CG","COG","XAF"],
    ["CH","CHE","CHF"],
    ["CI","CIV","XOF"],
    ["CK","COK","NZD"],
    ["CL","CHL","CLP"],
    ["CM","CMR","XAF"],
    ["CN","CHN","CNY"],
    ["CO","COL","COP"],
    ["CR","CRI","CRC"],
    ["CU","CUB","CUP"],
    ["CV","CPV","CVE"],
    ["CW","CUW","XCG"],
    ["CX","CXR","AUD"],
    ["CY","CYP","EUR"],
    ["CZ","CZE","CZK"],
    ["DE","DEU","EUR"],
    ["DG","DGA","USD"],
    ["DJ","DJI","DJF"],
    ["DK","DNK","DKK"],
    ["DM","DMA","XCD"],
    ["DO","DOM","DOP"],
    ["DZ","DZA","DZD"],
    ["EA","","EUR"],
    ["EC","ECU","USD"],
    ["EE","EST","EUR"],
    ["EG","EGY","EGP"],
    ["EH","ESH","MAD"],
    ["ER","ERI","ERN"],
    ["ES","ESP","EUR"],
    ["ET","ETH","ETB"],
    ["EU","QUU","EUR"],
    ["FI","FIN","EUR"],
    ["FJ","FJI","FJD"],
    ["FK","FLK","FKP"],
    ["FM","FSM","USD"],
    ["FO","FRO","DKK"],
    ["FR","FRA","EUR"],
    ["GA","GAB","XAF"],
    ["GB","GBR","GBP"],
    ["GD","GRD","XCD"],
    ["GE","GEO","GEL"],
    ["GF","GUF","EUR"],
    ["GG","GGY","GBP"],
    ["GH","GHA","GHS"],
    ["GI","GIB","GIP"],
    ["GL","GRL","DKK"],
    ["GM","GMB","GMD"],
    ["GN","GIN","GNF"],
    ["GP","GLP","EUR"],
    ["GQ","GNQ","XAF"],
    ["GR","GRC","EUR"],
    ["GS","SGS","GBP"],
    ["GT","GTM","GTQ"],
    ["GU","GUM","USD"],
    ["GW","GNB","XOF"],
    ["GY","GUY","GYD"],
    ["HK","HKG","HKD"],
    ["HM","HMD","AUD"],
    ["HN","HND","HNL"],
    ["HR","HRV","EUR"],
    ["HT","HTI","HTG","USD"],
    ["HU","HUN","HUF"],
    ["IC","","EUR"],
    ["ID","IDN","IDR"],
    ["IE","IRL","EUR"],
    ["IL","ISR","ILS"],
    ["IM","IMN","GBP"],
    ["IN","IND","INR"],
    ["IO","IOT","USD"],
    ["IQ","IRQ","IQD"],
    ["IR","IRN","IRR"],
    ["IS","ISL","ISK"],
    ["IT","ITA","EUR"],
    ["JE","JEY","GBP"],
    ["JM","JAM","JMD"],
    ["JO","JOR","JOD"],
    ["JP","JPN","JPY"],
    ["KE","KEN","KES"],
    ["KG","KGZ","KGS"],
    ["KH","KHM","KHR"],
    ["KI","KIR","AUD"],
    ["KM","COM","KMF"],
    ["KN","KNA","XCD"],
    ["KP","PRK","KPW"],
    ["KR","KOR","KRW"],
    ["KW","KWT","KWD"],
    ["KY","CYM","KYD"],
    ["KZ","KAZ","KZT"],
    ["LA","LAO","LAK"],
    ["LB","LBN","LBP"],
    ["LC","LCA","XCD"],
    ["LI","LIE","CHF"],
    ["LK","LKA","LKR"],
    ["LR","LBR","LRD"],
    ["LS","LSO","ZAR","LSL"],
    ["LT","LTU","EUR"],
    ["LU","LUX","EUR"],
    ["LV","LVA","EUR"],
    ["LY","LBY","LYD"],
    ["MA","MAR","MAD"],
    ["MC","MCO","EUR"],
    ["MD","MDA","MDL"],
    ["ME","MNE","EUR"],
    ["MF","MAF","EUR"],
    ["MG","MDG","MGA"],
    ["MH","MHL","USD"],
    ["MK","MKD","MKD"],
    ["ML","MLI","XOF"],
    ["MM","MMR","MMK"],
    ["MN","MNG","MNT"],
    ["MO","MAC","MOP"],
    ["MP","MNP","USD"],
    ["MQ","MTQ","EUR"],
    ["MR","MRT","MRU"],
    ["MS","MSR","XCD"],
    ["MT","MLT","EUR"],
    ["MU","MUS","MUR"],
    ["MV","MDV","MVR"],
    ["MW","MWI","MWK"],
    ["MX","MEX","MXN"],
    ["MY","MYS","MYR"],
    ["MZ","MOZ","MZN"],
    ["NA","NAM","NAD","ZAR"],
    ["NC","NCL","XPF"],
    ["NE","NER","XOF"],
    ["NF","NFK","AUD"],
    ["NG","NGA","NGN"],
    ["NI","NIC","NIO"],
    ["NL","NLD","EUR"],
    ["NO","NOR","NOK"],
    ["NP","NPL","NPR"],
    ["NR","NRU","AUD"],
    ["NU","NIU","NZD"],
    ["NZ","NZL","NZD"],
    ["OM","OMN","OMR"],
    ["PA","PAN","PAB","USD"],
    ["PE","PER","PEN"],
    ["PF","PYF","XPF"],
    ["PG","PNG","PGK"],
    ["PH","PHL","PHP"],
    ["PK","PAK","PKR"],
    ["PL","POL","PLN"],
    ["PM","SPM","EUR"],
    ["PN","PCN","NZD"],
    ["PR","PRI","USD"],
    ["PS","PSE","ILS","JOD"],
    ["PT","PRT","EUR"],
    ["PW","PLW","USD"],
    ["PY","PRY","PYG"],
    ["QA","QAT","QAR"],
    ["RE","REU","EUR"],
    ["RO","ROU","RON"],
    ["RS","SRB","RSD"],
    ["RU","RUS","RUB"],
    ["RW","RWA","RWF"],
    ["SA","SAU","SAR"],
    ["SB","SLB","SBD"],
    ["SC","SYC","SCR"],
    ["SD","SDN","SDG"],
    ["SE","SWE","SEK"],
    ["SG","SGP","SGD"],
    ["SH","SHN","SHP"],
    ["SI","SVN","EUR"],
    ["SJ","SJM","NOK"],
    ["SK","SVK","EUR"],
    ["SL","SLE","SLE"],
    ["SM","SMR","EUR"],
    ["SN","SEN","XOF"],
    ["SO","SOM","SOS"],
    ["SR","SUR","SRD"],
    ["SS","SSD","SSP"],
    ["ST","STP","STN"],
    ["SV","SLV","USD"],
    ["SX","SXM","XCG"],
    ["SY","SYR","SYP"],
    ["SZ","SWZ","SZL"],
    ["TA","TAA","GBP"],
    ["TC","TCA","USD"],
    ["TD","TCD","XAF"],
    ["TF","ATF","EUR"],
    ["TG","TGO","XOF"],
    ["TH","THA","THB"],
    ["TJ","TJK","TJS"],
    ["TK","TKL","NZD"],
    ["TL","TLS","USD"],
    ["TM","TKM","TMT"],
    ["TN","TUN","TND"],
    ["TO","TON","TOP"],
    ["TR","TUR","TRY"],
    ["TT","TTO","TTD"],
    ["TV","TUV","AUD"],
    ["TW","TWN","TWD"],
    ["TZ","TZA","TZS"],
    ["UA","UKR","UAH"],
    ["UG","UGA","UGX"],
    ["UM","UMI","USD"],
    ["US","USA","USD"],
    ["UY","URY","UYU"],
    ["UZ","UZB","UZS"],
    ["VA","VAT","EUR"],
    ["VC","VCT","XCD"],
    ["VE","VEN","VES"],
    ["VG","VGB","USD"],
    ["VI","VIR","USD"],
    ["VN","VNM","VND"],
    ["VU","VUT","VUV"],
    ["WF","WLF","XPF"],
    ["WS","WSM","WST"],
    ["XK","XKX","EUR"],
    ["YE","YEM","YER"],
    ["YT","MYT","EUR"],
    ["ZA","ZAF","ZAR"],
    ["ZM","ZMB","ZMW"],
    ["ZW","ZWE","ZWG","USD"],
];
